import { Component, inject } from '@angular/core';
import {FormControl, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {NgFor, NgIf} from '@angular/common';
import { AcctCreateService } from '../services/acct-create.service';
import { Router, RouterModule } from '@angular/router';
import firebase from 'firebase/compat/app';
import 'firebase/firestore';

@Component({
  selector: 'app-admin-user-creation',
  standalone: true,
  templateUrl: './admin-user-creation.component.html',
  imports: [ReactiveFormsModule, RouterModule, NgFor],
  styleUrls: [
    './admin-user-creation.component.css'
  ]
})

export class AdminUserCreationComponent {
  schools : any [] = [];
  roles: any [] = ['GHS Teacher Representative', 'Teacher', 'Admin', 'Science Directors'];
  grades: any [] = [ 'All Grades','K', '1st', '2nd', '3rd', '4th', '5th', '6th', '7th', '8th', '9th', '10th', '11th', '12th'];
  acctService = inject(AcctCreateService);

  constructor(private router: Router) {}

  async ngOnInit(){
    await this.getSchools();
  }

  async getSchools(){
    const snapshot = await firebase.firestore().collection('school').get();
    snapshot.forEach((doc) => this.schools.push((doc.data())));
    this.schools.sort((a, b) => a.name.localeCompare(b.name))
  }

  createForm = new FormGroup({
    title: new FormControl(''),
    firstName: new FormControl('', Validators.required),
    lastName: new FormControl('', Validators.required),
    role: new FormControl('', Validators.required),
    middleInit: new FormControl(''),
    grade: new FormControl(''),
    school: new FormControl(''),
    email: new FormControl('', [Validators.required, Validators.email])
  })
  async createUser() {
    if (this.createForm.invalid) {
      alert("Please fill all required fields.");
      return;
    }

    const email = this.createForm.value.email!;
    const tempPassword = Math.random().toString(36).slice(-8); // temporary password

    try {
      const created = await this.acctService.submitAcct(
        this.createForm.value.title || '',
        this.createForm.value.firstName!,
        this.createForm.value.lastName!,
        this.createForm.value.role!,
        this.createForm.value.middleInit || '',
        this.createForm.value.grade || null,
        this.createForm.value.school || null,
        email,
        tempPassword,
        tempPassword
      );

      if (!created) {
        return;
      }

      // send reset password only if user was actually created
      await this.acctService.sendResetPassword(email);

      alert("User created! Password reset email sent.");
      await this.router.navigate(['/profile']);

    } catch (err) {
      console.error(err);
      alert("Something went wrong creating the user.");
    }
  }

}
